var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('img',{staticClass:"activity-img",attrs:{"src":require("../../assets/images/activity/video-banner-detail.png")}}),_c('img',{staticClass:"gotoBtn",attrs:{"src":require("../../assets/images/activity/video-toBtn.png")},on:{"click":function($event){return _vm.goEnroll()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }